import { Control, Controller } from 'react-hook-form';
import Autocomplete from '@mui/material/Autocomplete';
import { Input } from '../Input';

export interface AutocompleteControlledProps {
  control: Control;
  name: string;
  label: string;
  options: any[];
  onChange: any;
}

export const AutocompleteInput = ({
  name,
  control,
  options,
  onChange,
  label,
}: AutocompleteControlledProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field: { value, onBlur, ref }, fieldState: { error } }) => (
        <Autocomplete
          freeSolo
          options={options}
          value={value}
          onChange={onChange}
          ref={ref}
          onBlur={onBlur}
          renderInput={params => (
            <Input
              onChange={onChange}
              value={value}
              ref={ref}
              name={name}
              label={label}
              control={control}
              error={!!error}
              {...params}
            />
          )}
          sx={{ width: '100%' }}
        />
      )}
    />
  );
};
